/* eslint-disable camelcase */
import Flex from 'common/components/Flex'
import Image from 'common/components/Image'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import { useState } from 'react'
import styled from 'styled-components'

const CardCustom = styled.div`
  width: 198px;
  height: 96px;
  padding: 10px 15px;
  border-radius: 6px;
  border: solid 1px
    ${(props) =>
      props.isActive ? theme.colors.orange : theme.colors.grayLight};
  background-color: ${(props) =>
    props.isActive ? theme.colors.orange1 : theme.colors.white};
  text-align: center;
  cursor: pointer;
  ${(props) =>
    props.responsive &&
    `
    @media (max-width: 575.98px) {
      height: 108px;
    }
    @media (max-width: 1199.98px) {
      width: 100%;
      + div {
        margin-left: 20px;
      }
    }
  `}
`

interface IRadioCard {
  onChange: (value: string) => void
  options: Array<{
    id: string
    option: string
    description: string
    image_url: string
    sort: number
    next_questions?: {
      url: string
      method: string
    }
  }>
  defaultValue?: string
  responsive?: boolean
}

function RadioCard({
  onChange,
  options,
  defaultValue = '',
  responsive = false,
}: IRadioCard): JSX.Element {
  const [selectedCard, handleSelectedCard] = useState(defaultValue)

  const handleChange = (value) => {
    handleSelectedCard(value.id)
    onChange(value)
  }
  return (
    <Flex
      justifyContent="space-between"
      flexDirection="row"
      data-testid="radio-profile-type-wrapper"
      margin="0 0 20px"
    >
      {options &&
        options.map((opt) => (
          <CardCustom
            key={opt.id}
            isActive={opt.id === selectedCard}
            onClick={() => handleChange(opt)}
            data-testid={`card-${opt.option}`}
            responsive={responsive}
          >
            <Image
              lazy
              src={opt.image_url}
              height="38px"
              width="38px"
              objectFit="contain"
            />
            <Typography
              marginTop="8px"
              fontSize="13px"
              fontWeight="bold"
              color={`${
                opt.id === selectedCard ? 'orange' : 'black'
              }`}
              textAlign="center"
            >
              {opt?.option}
            </Typography>
            <Typography
              marginTop="7px"
              fontSize="11px"
              textAlign="center"
            >
              {opt?.description}
            </Typography>
          </CardCustom>
        ))}
    </Flex>
  )
}

export default RadioCard
